import cx from 'classnames'
import Button from 'react-bootstrap/Button'
import Icon from '../../Icon/Icon'

import './ButtonLink.scss'

const ButtonLink = ({ children, size = 'lg', className, onClick, iconLeft, iconRight, ...props }) => {
    return (
        <Button
            variant="default"
            size={size}
            onClick={onClick}
            className={cx(
                'button-link d-flex align-items-center justify-content-center text-white bg-none rounded-0',
                className
            )}
            {...props}
        >
            {iconLeft && <Icon name={iconLeft} className={'me-2'} />}
            {children}
            {iconRight && <Icon name={iconRight} className={'ms-2'} />}
        </Button>
    )
}

export default ButtonLink
